/**
 * Allow only same-app relative paths (no protocol-relative //… open redirects).
 */
export function safeAppPath(path: string | null | undefined): string {
    if (path == null || typeof path !== "string") return "/"
    const trimmed = path.trim()
    if (!trimmed.startsWith("/") || trimmed.startsWith("//")) return "/"
    return trimmed
}

/** Destination after email verification from optional `returnTo` query param. */
export function verifyEmailRedirectDestination(
    returnToParam: string | null
): string {
    if (returnToParam == null || returnToParam === "") return "/"
    return safeAppPath(returnToParam)
}
